import React from 'react';
import { ListGroupItem, Label, Input } from 'reactstrap';
import i18n from '../../../../../i18next';

const AllergensAndDietaryListItem = props => {

    const { allAndDietListGroupItem, allAndDietLabel, allAndDietInput } = styles;

    return (
        <ListGroupItem
            className={props.className}
            style={allAndDietListGroupItem}>
            <Label style={allAndDietLabel}>{i18n.t(`common:${props.itemType}.${props.item.value}`)}</Label>
            <Input
                type="checkbox"
                id={props.item.id}
                name={`${props.item.value}`}
                style={allAndDietInput}
                checked={props.isChecked(props.item.id, props.itemType)}
                onChange={(event) => props.addOrRemoveItemsInState(event, props.itemType)}
            />
        </ListGroupItem>
    );
}

export default AllergensAndDietaryListItem;

const styles = {
    allAndDietListGroupItem: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1px 10px 1px 10px',
        marginBottom: 6,
        border: 'none',
        borderBottom: '1px solid #ced4da',
        borderRadius: 0
    },
    allAndDietLabel: {
        justifyContent: 'flex-start',
        width: '90%',
        whiteSpace: 'normal'
    },
    allAndDietInput: {
        right: '7%',
        width: '12px',
        height: '12px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/alergensAndDietary/AllergensAndDietaryListItem.js